import { Component } from '@angular/core';
import { InternalAppService, Language } from 'src/services/app.service';
import { Option } from 'src/util/types/global';

/**
* @ignore - do not show in documentation
*/
@Component({
  selector:    'v-language-selector',
  templateUrl: './v-language-selector.component.haml',
  styleUrls:   ['./v-language-selector.component.sass'],
  standalone:  false
})
export class VLanguageSelectorComponent {

  languages: Option[];
  #lang: Language;
  get selectedLanguage(): Language{
    return this.#lang;
  };
  set selectedLanguage(value: Language){
    if (value === this.#lang)
      return;
    this.#lang = value;
    if (this.service.locale !== value)
      this.service.__setLocale(value);
  };
  constructor(public service: InternalAppService) {
    this.languages = service.languages.map(x => ({label: x, value: x}));
    this.selectedLanguage = service.locale;
  }
}
